module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppsorrowend0006#toc"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To Katherine V. Forrest, Judy Greber (Gillian Roberts), Michael Nava, Katherine Neville, and Sarah Smith."), _c('br', {
    staticClass: "calibre1"
  }), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Thank you for all you taught me in class and"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("continue to teach me through your books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb2d00e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-sorrowend0005.vue
// module id = 72
// module chunks = 0